<ng-container>
	<div fxLayout="column" style="padding:16px;background: linear-gradient(#242424,#141414);" ngClass.xs="shotdata_xs">
		<div fxFlex="5" fxLayoutAlign="start center" style="background-color:#242424;">
			<div fxLayout="row" class="title" style="color: #ffffff;">
				<img data-idtest="staticvideo-a-8Sy" src="/images/staticvideo_logo.png" style="width:10%;">
				<div class="card-title" style="padding-left:10px;"><span translate>{{RowNameByType(0)}}</span></div>
			</div>
		</div>
		<div *ngFor="let row of VideoRowsByType(0)">
			<mat-card style="margin:20px;background-color: rgb(25,25,25);margin-top: 32px;">
				<div class="sub-title" fxLayout="row" style="color: #fdfdfd;">
					<span *ngIf="row.noobs"><img src="/images/noobs.svg" style="display: inherit;width:20px;"></span>
					<div class="card-title"><span translate>{{ColumnNameByIndex(row, 0)}}</span></div>
				</div>
				<div *ngFor="let sub of VideoSubCategoriesByIndex(row,0)">
					<mat-grid-list (window:resize)="onResize($event)" [cols]="breakpoint" [gutterSize]="gutter" [rowHeight]="breakpoint_rh">
						<div fxLayout="column">
							<div class="category-name">{{sub.name}}</div>
							<div *ngFor="let file of VideoColumnsByIndex(sub,0)">
								<mat-grid-tile colspan="1" rowspan="1" class="box-body">
									<div style="height: 100%;" *ngIf="breakpoint !== 1">
										<img (click)="onVideo(file)" [src]="thumbnail(file)" style="height: 55%;">
										<mat-grid-tile-footer fxLayout="row" fxLayoutAlign="space-around center" style="bottom:inherit;background:none;height:70px;">
											<div>
												<span *ngIf="file.metadata.noobs"><img data-idtest="staticvideo-a-7Ah" src="/images/noobs.svg" style="display: inherit;width:12px;"></span>
												<span class="box-header">{{translateOne(file.metadata.description)}}</span>
											</div>
										</mat-grid-tile-footer>
									</div>
									<div style="height: 100%;" fxLayout="row" *ngIf="breakpoint === 1">
										<img (click)="onVideo(file)" [src]="thumbnail(file)" style="height: 60%;">
										<mat-grid-tile-footer fxLayout="row" fxLayoutAlign="space-around center" style="bottom:inherit;background:none;height:70px;position: inherit;padding: 0 8px;">
											<div>
												<span *ngIf="file.metadata.noobs"><img src="/images/noobs.svg" style="display: inherit;width:12px;"></span>
												<span class="box-header">{{translateOne(file.metadata.description)}}</span>
											</div>
										</mat-grid-tile-footer>
									</div>
								</mat-grid-tile>
							</div>
						</div>
					</mat-grid-list>
				</div>
			</mat-card>
		</div>
	</div>
</ng-container>
